/**
 * Translation: NL - Validator
 * Note, also export in translations/{LANGUAGE}/index.js
 */
export default {
  'validator.messageValueMissing': 'Dit veld is niet (correct) ingevuld.',
  'validator.messageValueMissingCheckbox': 'Dit veld is verplicht',
  'validator.messageValueMissingRadio': 'Selecteer een waarde',
  'validator.messageValueMissingSelect': 'Kies een waarde',
  'validator.messageValueMissingSelectMulti': 'Maak hierbij minimaal één keuze',
  'validator.messageTypeMismatchEmail': 'Vul een geldig e-mailadres in.',
  'validator.messageTypeMismatchURL': 'Vul een geldige url in.',
  'validator.messageTooShort': 'In dit veld zijn er minimaal {minLength} karakters nodig. Je gebruikt nu {length} karakaters.',
  'validator.messageTooLong': 'Sorry. Je hebt teveel karakters gebruikt. Je gebruikt nu {length} karakters en er is een maximum van {maxLength}.',
  'validator.messagePatternMismatch': 'Dit veld is niet correct ingevuld.',
  'validator.messageBadInput': 'Je dient hier een getal in te voeren.',
  'validator.messageStepMismatch': 'Vul een geldige waarde in.',
  'validator.messageRangeOverflow': 'Selecteer een waarde die kleiner is dan {max}.',
  'validator.messageRangeUnderflow': 'Selecteer een waarde die groter is dan {min}.',
  'validator.messageGeneric': 'Dit is een waarde die in dit veld niet correct is.',
};
